<template>
  <i class="sns-logo" :style="logoStyle">
    <img
      v-if="snsName === 'kakao'"
      :width="width"
      :height="height"
      src="@/assets/images/sns/ico-sns-kakao.svg"
      alt="kakao-logo"
    />
    <img
      v-if="snsName === 'tid'"
      :width="width"
      :height="height"
      src="@/assets/images/sns/ico-sns-tid.svg"
      alt="tid-logo"
    />
    <img
      v-if="snsName === 'naver'"
      :width="width"
      :height="height"
      src="@/assets/images/sns/ico-sns-naver.svg"
      alt="naver-logo"
    />
    <img
      v-if="snsName === 'facebook'"
      :width="width"
      :height="height"
      src="@/assets/images/sns/ico-sns-facebook.svg"
      alt="facebook-logo"
    />
    <img
      v-if="snsName === 'apple'"
      :width="width"
      :height="height"
      src="@/assets/images/sns/ico-sns-apple.svg"
      alt="apple-logo"
    />
  </i>
</template>

<script setup>
  import { computed } from 'vue'

  const props = defineProps({
    // snsName: 'kakao' | 'naver' | 'facebook' | 'tid' | 'apple'
    snsName: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 60,
    },
    height: {
      type: Number,
      default: 60,
    },
  })

  const logoStyle = computed(() => ({
    width: `${props.width}px`,
    height: `${props.height}px`,
  }))
</script>

<style lang="scss" scoped>
  .sns-logo {
    flex: none;
  }
</style>
